import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import notificationData from 'store/api/announcement.api';
import { CONSTANTS } from 'common/constants';

interface NState {
    Title: string;
    StartDate: string;
    EndDate: string;
}

interface IState {
    data: NState[];
    status: string;
}

const initialState: IState = {
    data: [],
    status: CONSTANTS.IDLE
};

export const notificationAPI = createAsyncThunk('home/notification', async () => {
    const response = await notificationData();
    return response;
});

export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(notificationAPI.pending, (state) => {
                state.status = CONSTANTS.LOADING;
            })
            .addCase(notificationAPI.fulfilled, (state, action) => {
                state.status = CONSTANTS.FULFILLED;
                const filteredDate = action.payload.filter((value: NState) => {
                    if (new Date(value.StartDate) <= new Date() && new Date(value.EndDate) >= new Date()) {
                        return true;
                    }
                    return false;
                });
                state.data = filteredDate;
            });
    }
});

export default notificationSlice.reducer;
